/**
 * @descriptino All triangle shaped plugins extend this class. Provides a bunch of util methods
 *
 */
export class FabricTriangle {
    points;

    // Returns true if point P inside the triangle with vertices at A, B and C
    // representing 2D vectors and points as [x,y]. Based on
    // http://www.blackpawn.com/texts/pointinpoly/default.html
    isPointInTriangle(P, A, B, C) {
        // Compute vectors
        function vec(from, to) { return [to[0] - from[0], to[1] - from[1]]; }
        const v0 = vec(A, C);
        const v1 = vec(A, B);
        const v2 = vec(A, P);
        // Compute dot products
        function dot(u, v) { return u[0] * v[0] + u[1] * v[1]; }
        const dot00 = dot(v0, v0);
        const dot01 = dot(v0, v1);
        const dot02 = dot(v0, v2);
        const dot11 = dot(v1, v1);
        const dot12 = dot(v1, v2);
        // Compute barycentric coordinates
        const invDenom = 1.0 / (dot00 * dot11 - dot01 * dot01);
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // Check if point is in triangle
        return (u >= 0) && (v >= 0) && (u + v < 1);
    }

    setPoints(points) {
        this.points = points;
    }

    getPoints() {
        return this.points;
    }
}
